import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import * as dates from 'react-big-calendar/lib/utils/dates'
import { format } from 'date-fns'
import moment from "moment-timezone";

import EventWrapper from './EventWrapper'
import { DnDContext } from '../DnDContext';

class EventCell extends React.Component {
    static contextType = DnDContext;

    render() {
        let {
            style,
            className,
            event,
            selected,
            isAllDay,
            onSelect,
            onDoubleClick,
            onKeyPress,
            localizer,
            continuesPrior,
            continuesAfter,
            accessors,
            getters,
            children,
            slotStart,
            slotEnd,
            ...props
        } = this.props
        delete props.resizable

        const { draggable, slotHandlers, extraProps } = this.context
        const timezone = extraProps['timezone']
        
        let end = event.end
        let start = event.start
        let allDay = event.allDay
        let showAsAllDay =
            isAllDay || allDay || dates.diff(start, dates.ceil(end, 'day'), 'day') > 1 || start.isSame(end)
        const startTime = moment(event.start).tz(timezone).format('h:mma')
        let title = event.allDay ? event.title 
                    : showAsAllDay ? event.title
                    : `${startTime.toLowerCase()} ${event.title}`
        let tooltip = event.tooltip
        
        const content = (
            <div className="rbc-event-content" title={title} style={{fontSize: '0.8rem'}}>
                {title}
            </div>
        )

        return (
            <EventWrapper {...this.props} type="date">
                <div
                    {...props}
                    tabIndex={0}
                    style={{ ...style }}
                    className={clsx('rbc-event', className, {
                        'rbc-selected': selected,
                        'rbc-event-allday': showAsAllDay,
                        'rbc-event-continues-prior': continuesPrior,
                        'rbc-event-continues-after': continuesAfter,
                    })}
                    onClick={e => onSelect && onSelect(event, e)}
                    onDoubleClick={e => onDoubleClick && onDoubleClick(event, e)}
                    onKeyPress={e => onKeyPress && onKeyPress(event, e)}
                >
                    {typeof children === 'function' ? children(content) : content}
                </div>
            </EventWrapper>
        )
    }
}

EventCell.propTypes = {
    event: PropTypes.object.isRequired,
    slotStart: PropTypes.instanceOf(Date),
    slotEnd: PropTypes.instanceOf(Date),

    resizable: PropTypes.bool,
    selected: PropTypes.bool,
    isAllDay: PropTypes.bool,
    continuesPrior: PropTypes.bool,
    continuesAfter: PropTypes.bool,

    accessors: PropTypes.object.isRequired,
    getters: PropTypes.object.isRequired,
    localizer: PropTypes.object,

    onSelect: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onKeyPress: PropTypes.func,
}

export default EventCell
